/** @format */

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import {
    StickyBar,
    StickyClose,
    StickyGhost,
    StickyPrimary,
    StickyText,
} from "./styles";

/**
 * Keeps the sign-up path one tap away once the visitor scrolls past the hero.
 * Dismissible, and hidden again near the footer so it never covers the
 * in-page CTAs.
 */
const CircleStickyCTA: React.FC = () => {
    const { t } = useTranslation("home");
    const navigate = useNavigate();
    const [shown, setShown] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (dismissed) return;
        let frame = 0;
        const onScroll = () => {
            if (frame) return;
            frame = window.requestAnimationFrame(() => {
                frame = 0;
                const y = window.scrollY;
                const nearBottom =
                    y + window.innerHeight > document.body.scrollHeight - 900;
                setShown(y > window.innerHeight * 0.85 && !nearBottom);
            });
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            if (frame) window.cancelAnimationFrame(frame);
            window.removeEventListener("scroll", onScroll);
        };
    }, [dismissed]);

    return (
        <StickyBar shown={shown && !dismissed} role="region" aria-label={t("memberSection.cta")}>
            <StickyText>{t("memberSection.cta")}</StickyText>
            <StickyPrimary
                variant="contained"
                disableElevation
                endIcon={<ArrowForwardIcon />}
                onClick={() => navigate("/circle/sign-up")}>
                {t("bannerOne.cta")}
            </StickyPrimary>
            <StickyGhost
                variant="text"
                onClick={() => navigate("/sandbox/demo")}>
                {t("bannerOne.tryLiveDemo")}
            </StickyGhost>
            <StickyClose
                type="button"
                aria-label={t("common:buttons.close", { defaultValue: "Close" })}
                onClick={() => setDismissed(true)}>
                <CloseIcon sx={{ fontSize: 17 }} />
            </StickyClose>
        </StickyBar>
    );
};

export default CircleStickyCTA;
